import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
import API from "../../../api/index";
import { connect } from "react-redux";
import { logoutUser } from "Redux/actions";
import "react-circular-progressbar/dist/styles.css";
import "react-tabs/style/react-tabs.css";
import { Row, Card, Button, Input, Form, FormGroup, CardTitle, Label, Collapse, CardBody, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { Colxx } from "Components/CustomBootstrap";
import moment from "jalali-moment";
import NumberFormat from "react-number-format";
import StateButton from "Components/StateButton";
import Tooltip from "react-simple-tooltip";

class Coupon extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			deactiveClicked: false,
			coupon: {
				customer: false,
			},
			couponUsesTableIsLoading: true,
			couponUsesTableCurrentPage: 1,
			couponUses: [],
		};
		this.loadData = this.loadData.bind(this);
		this.handleDeactiveButtonClick = this.handleDeactiveButtonClick.bind(this);
		this.loadUsageData = this.loadUsageData.bind(this);
		this.loadData();
	}
	handleFocus = (event) => event.target.select();
	loadData() {
		API.post("crm/coupon/get", { couponID: this.props.match.params.couponID })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState(
					{
						coupon: data,
						isLoading: false,
					},
					() => {
						this.loadUsageData();
					}
				);
			})
			.catch((error) => {});
	}
	loadUsageData() {
		API.post("crm/coupon/uses-list", { couponID: this.props.match.params.couponID, currentPage: this.state.couponUsesTableCurrentPage })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					couponUses: data.couponUses,
					paging: data.paging,
					couponUsesTableIsLoading: false,
				});
			})
			.catch((error) => {});
	}
	handleDeactiveButtonClick() {
		return new Promise((success, fail, $this) => {
			if (confirm("آیا از باطل کردن این کوپن اطمینان دارید؟")) {
				this.setState({ deactiveClicked: true });

				API.post("crm/coupon/deactive", { couponID: this.props.match.params.couponID })
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

						if (data.ERRORS !== undefined) {
							fail("خطا در ثبت ابطال کوپن");
							for (var i = 0; i < data.ERRORS.length; i++) {
								setTimeout(
									function (err) {
										NotificationManager.error(err, "خطا در ثبت ابطال کوپن", 8000, null, null, "filled");
									},
									(i + 1) * 700,
									data.ERRORS[i]
								);
								this.setState({
									deactiveClicked: false,
								});
							}
						} else {
							success("ابطال کوپن ثبت شد");
							setTimeout(() => {
								const couponObj = { ...this.state.coupon };
								couponObj.isDeleted = true;
								couponObj.isUseable = false;
								this.setState({ deactiveClicked: false, coupon: couponObj });
							}, 1000);
						}
					})
					.catch((error) => {
						fail("خطا در ثبت ابطال کوپن");
					});
			} else {
				fail("خطا در ثبت ابطال کوپن");
			}
		});
	}

	render() {
		const typeMappings = {
			PERCENT: "%",
			FIXED: "تومان",
		};

		return false ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row>
					<Colxx xl="12">
						<Form>
							<FormGroup row>
								<Colxx sm={6}>
									<Card className="timeline-card " style={{ backgroundColor: "transparent" }} id={"side-card"}>
										<CardBody style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
											<CardTitle>
												<div className={"iconsminds-calendar-4 headingicon"} />
												استفاده از کوپن
											</CardTitle>
											<div className="">
												{!this.state.couponUsesTableIsLoading ? (
													<div className="table-responsive">
														<table className="table table-hover order-table">
															<thead>
																<tr>
																	<th>#</th>
																	<th>سفارش</th>
																	<th>مشتری</th>
																	<th>تخفیف کل</th>
																	<th>بیشتر</th>
																</tr>
															</thead>
															{this.state.couponUses.map((row) => (
																<CouponUseTableRow key={row.couponUseId} data={row} />
															))}
															<tfoot>
																<tr>
																	<td colSpan={12}>
																		<div className="table-pagination">
																			{this.state.paging.pages.map((page, index) => (
																				<Button
																					key={index}
																					className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																					onClick={(e) => {
																						if (page.ellipse) {
																							return;
																						}

																						this.setState({ couponUsesTableCurrentPage: page.page, couponUsesTableIsLoading: true }, () => {
																							this.loadUsageData();
																						});
																					}}
																				>
																					{page.page}
																				</Button>
																			))}

																			<div className={"text-muted"} style={{ display: "block", clear: "both", marginTop: "16px", fontSize: "14px" }}>
																				نمایش {this.state.paging.from + 1} - {Math.min(this.state.paging.to, this.state.paging.total)} از {this.state.paging.total} استفاده از کوپن
																			</div>
																		</div>
																	</td>
																</tr>
															</tfoot>
														</table>
													</div>
												) : (
													<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
												)}
											</div>
										</CardBody>
									</Card>
								</Colxx>
								<Colxx sm={6}>
									<Card>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>
												<div className={"iconsminds-project headingicon"} />
												مشخصات کوپن
											</CardTitle>
											<CardTitle>
												<div style={{ display: "block", clear: "both", float: "left", width: "100%", marginBottom: "20px" }}>
													<div className="coupon" style={{ color: this.state.coupon.isUseable == false ? "red" : "#556270", float: "left" }}>
														<span>{this.state.coupon.code}</span>
													</div>
													{this.state.coupon.isUseable == true ? (
														<div style={{ float: "right", fontSize: "14px", marginTop: "14px" }} className={"text-muted"}>
															<StateButton disabled={this.state.deactiveClicked} id="cancleButton" color="danger" className="mb-2 btn-just-icon" onClick={() => this.handleDeactiveButtonClick()}>
																<i className={"simple-icon-close"}></i>
															</StateButton>
														</div>
													) : (
														<></>
													)}
												</div>
											</CardTitle>
											<div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"simple-icon-plus"}></i>
														<strong>ایجاد شده: </strong>&nbsp; {moment(this.state.coupon.createdAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"iconsminds-consulting"}></i>
														<strong>ایجاد شده: </strong>&nbsp; {this.state.coupon.operatorName}
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"simple-icon-clock"}></i>
														<strong>انقضا: </strong>&nbsp;{moment(this.state.coupon.expiresAt).locale("fa").format("DD / MMMM / YYYY - HH:mm")}
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"simple-icon-check"}></i>
														<strong>میزان مصرف: </strong>&nbsp;{this.state.coupon.usage}
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"iconsminds-financial"}></i>
														<strong>مقدار: </strong>&nbsp;{" "}
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.coupon.amount}
															className="text-muted"
															displayType={"text"}
															suffix={" " + typeMappings[this.state.coupon.type]}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"simple-icon-handbag"}></i>
														<strong> حد اقل سفارش: </strong>&nbsp;
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.coupon.minSpend}
															className="text-muted"
															displayType={"text"}
															suffix={" تومان"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className={"box-meta box-meta-half-width"}>
													<div>
														<i className={"iconsminds-folders"}></i>
														<strong> موضوع:</strong>&nbsp; {this.state.coupon.subject}
													</div>
												</div>
												{this.state.coupon.customer != false ? (
													<div className={"box-meta box-meta-half-width"}>
														<div>
															<i
																className={classNames({
																	"iconsminds-business-man": this.state.coupon.customer.Gender.toLowerCase() == "male" ? true : false,
																	"iconsminds-business-woman": this.state.coupon.customer.Gender.toLowerCase() == "female" ? true : false,
																})}
															></i>
															{this.state.coupon.customer.Name} {this.state.coupon.customer.SurName} - &nbsp;
															<a target="_blank" className={"text-muted"} href={"/app/customers/view-customer/" + this.state.coupon.customer.Mobile}>
																{this.state.coupon.customer.Mobile}
																<div className={" simple-icon-arrow-left-circle icongotoorder"} />
															</a>
														</div>
													</div>
												) : (
													<></>
												)}
											</div>
										</CardBody>
										<div className={"cutline"}></div>
										<CardBody>
											<div className={"box-meta"}>
												<div>
													<i className={"simple-icon-info"}></i>
													<strong>توضیح:</strong>&nbsp; {this.state.coupon.description}
												</div>
											</div>
										</CardBody>
									</Card>
								</Colxx>
							</FormGroup>
						</Form>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class CouponUseTableRow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
		};
		this.toggle = this.toggle.bind(this);
	}
	toggle() {
		if (this.state.clicked) {
			return;
		}
		this.setState({
			modal: !this.state.modal,
		});
	}

	render() {
		const {
			data: { couponUseId, createdAt, orderId, customerId, customer, totalPrice, description, totalDiscount, payable, isDeleted, operatorName },
		} = this.props;
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td className={"text-muted"} style={{ verticalAlign: "middle" }}>
						{couponUseId}{" "}
						<i
							style={{ color: isDeleted == "1" ? "red" : "green" }}
							className={classNames({
								"simple-icon-close": isDeleted == "1" ? true : false,
								"simple-icon-check": isDeleted == "0" ? true : false,
							})}
						></i>
						<br />
						{moment(createdAt).locale("fa").format("YYYY/MM/DD - HH:mm")}
					</td>
					<td style={{ verticalAlign: "middle" }}>
						<a href={"/app/orders/view-order/" + orderId} target="_blank">
							<span>{orderId}</span> <div className={" simple-icon-arrow-left-circle icongotoorder"} />
							<br />
							<span className={"text-muted"}>
								<NumberFormat style={{ textAlign: "center" }} value={totalPrice} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
							</span>
						</a>
					</td>
					<td style={{ verticalAlign: "middle" }}>
						<a href={"/app/customers/view-customer/" + customer.Mobile} target="_blank">
							<span>{customer.Mobile}</span> <div className={" simple-icon-arrow-left-circle icongotoorder"} />
							<br />
							<span className={"text-muted"}>
								<i
									className={classNames({
										"iconsminds-business-man": customer.Gender.toLowerCase() == "male" ? true : false,
										"iconsminds-business-woman": customer.Gender.toLowerCase() == "female" ? true : false,
									})}
								></i>{" "}
								{customer.Name} {customer.SurName}
							</span>
						</a>
					</td>
					<td className={"text-muted"} style={{ verticalAlign: "middle" }}>
						<span style={{ display: "inline-block" }}>
							<NumberFormat style={{ textAlign: "center" }} value={totalDiscount} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
						</span>
						<br />
						<span className={"text-muted"}>
							<i className={"iconsminds-consulting"}></i> {operatorName}
						</span>
					</td>
					<td className={"text-muted"}>
						<Button
							className="mb-2 btn-just-icon"
							outline
							color="primary"
							style={{ margin: "0" }}
							onClick={() => {
								this.setState({ modal: true });
							}}
						>
							<i className={"simple-icon-info"}></i>
						</Button>
						<Modal isOpen={this.state.modal} toggle={this.toggle}>
							<ModalHeader toggle={this.toggle}>استفاده از کوپن #{couponUseId}</ModalHeader>
							<ModalBody>
								<table style={{ width: "100%" }}>
									<tbody>
										<tr style={{ verticalAlign: "top" }}>
											<th>توضیحات:</th>
											<td>
												<ul style={{ direction: "ltr", textAlign: "left" }}>
													{description.split("|").map((part, index) => (
														<li key={index}>{part.trim()}</li>
													))}
												</ul>
											</td>
										</tr>
										<tr>
											<th>جمع کل:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={totalPrice} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>تخفیف کل:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={totalDiscount} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>قابل پرداخت:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={payable} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>وضعیت:</th>
											<td>
												<i
													style={{ color: isDeleted == "1" ? "red" : "green" }}
													className={classNames({
														"simple-icon-close": isDeleted == "1" ? true : false,
														"simple-icon-check": isDeleted == "0" ? true : false,
													})}
												></i>{" "}
												<span style={{ color: isDeleted == "1" ? "red" : "green" }}>
													{classNames({
														"باطل شده": isDeleted == "1",
														"اعمل شده": isDeleted == "0",
													})}
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</ModalBody>
						</Modal>
					</td>
				</tr>
			</tbody>
		);
	}
}
const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(Coupon));
